import React from 'react';
import { Container, Row, Col, Image } from 'react-bootstrap';
import * as S from './styles';

export interface ITeamSectionProps {
  sectionId?: string;
  backgroundImage?: string;
  smallImage?: string;
}

export const TeamSection: React.FC<ITeamSectionProps> = ({ sectionId, backgroundImage, smallImage }) => {
  return (
    <section
      className="section section-md pt-lg-5"
      id={sectionId}
      style={{ background: 'linear-gradient(to right, #272727, #8D8D8D)', position: 'relative' }}
    >
      <Container>
        <Row className="align-items-center justify-content-between">
          <Col lg={2} className="position-relative d-flex justify-content-end">
            <Image
              src={smallImage}
              alt="Team Member Small"
              className="rounded-circle"
              style={{ width: '80px', height: '80px', objectFit: 'cover', marginRight: '15px' }}
            />
          </Col>
          <Col lg={6} className="position-relative text-white">
            <S.Title>Our Team</S.Title>
            <h3 className="text-2xl font-semibold mb-4">Expert Work Permit Specialists</h3>
            <S.Description>Meet our professional team dedicated to assisting you with work permits.</S.Description>
          </Col>
          <Col lg={4} className="position-relative d-flex justify-content-start">
            <Image
              src={backgroundImage}
              alt="Team Member Large"
              className="rounded-circle"
              style={{ width: '250px', height: '250px', objectFit: 'cover', marginLeft: '-30px' }}
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
};

TeamSection.defaultProps = {
  sectionId: 'team-section',
  backgroundImage: 'https://i.ibb.co/xK5R2X4H/a1a57d4e2f5b49a693cad277e3da4d36335ea50f.jpg',
  smallImage: 'https://i.ibb.co/CKbYtC8B/pexels-photo-8204373.jpg',
};

export default TeamSection;